export const NAME_SPACES = {
  GLOBAL: "global",
  HOME: "home",
  FILES: "files",
  AUTH: "auth",
  LAYOUT: "layout",
  ERRORS: "errors",
  NEW_FOLDER: "newFolder",
  COMPONENTS: "components",
  ACCOUNT: "account",
  ADDRESS: "address",
  CONTACT_US: "contactUs",
};

export const DEFAULT_VALUES = {
  NOTIFICATION_DURATION: 10,
};
